import { RankedTester, and, rankWith, optionIs, schemaTypeIs } from "@jsonforms/core";

export const SelectProviderTester: RankedTester = rankWith(
  3,
  and(schemaTypeIs("string"), optionIs("selectProvider", true))
);

export default SelectProviderTester;
